import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_col = _resolveComponent("oio-col")!
  const _component_oio_row = _resolveComponent("oio-row")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_oio_pagination = _resolveComponent("oio-pagination")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oio_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.queryRemote ? _ctx.onShowModalRemote() : _ctx.onShowModal()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("添加")
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      class: "oio-modal",
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showModal) = $event)),
      title: "添加",
      onOk: _ctx.onConfirm,
      width: 1000
    }, {
      default: _withCtx(() => [
        _createVNode(_component_oio_form, {
          data: _ctx.searchData,
          layout: "inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oio_row, { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_component_oio_col, { flex: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, { label: "平台客户编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.searchData.targetPartnerCode,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchData.targetPartnerCode) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.getPropKeyName() !== 'platformSuitDistributors')
                  ? (_openBlock(), _createBlock(_component_oio_col, {
                      key: 0,
                      flex: 7
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_form_item, { label: "ERP客户编码" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oio_input, {
                              value: _ctx.searchData.customerErpCode,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchData.customerErpCode) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_oio_col, { flex: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, { label: "客户名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_input, {
                          value: _ctx.searchData.targetPartnerName,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchData.targetPartnerName) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_oio_col, { flex: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oio_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_oio_button, {
                          type: "primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.queryRemote ? _ctx.onSearchRemote() : _ctx.onSearch()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("搜索")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_oio_spin, { loading: _ctx.tableLoading }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_table, {
              border: "",
              ref: "tableRef",
              "max-height": "400",
              "keep-source": "",
              "column-config": { resizable: true },
              data: _ctx.showData,
              onCheckboxChange: _ctx.checkboxChangeEvent,
              onCheckboxAll: _ctx.checkboxChangeEvent
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  field: "targetPartnerCode",
                  title: "平台客户编码",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  field: "customerErpCode",
                  title: "ERP客户编码",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  field: "targetPartnerName",
                  title: "客户名称",
                  align: "center"
                })
              ]),
              _: 1
            }, 8, ["data", "onCheckboxChange", "onCheckboxAll"]),
            _createVNode(_component_oio_pagination, {
              style: {"margin-top":"12px"},
              current: _ctx.current,
              "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.current) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
              total: _ctx.total,
              "show-total": (total) => `${total} 条`,
              "show-quick-jumper": "",
              onChange: _cache[7] || (_cache[7] = (page, size) => (_ctx.queryRemote ? _ctx.onChangeRemote(page, size) : _ctx.onChange(page, size)))
            }, null, 8, ["current", "page-size", "total", "show-total"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
}